import React, { FC } from "react";

import { KpkMedia } from "@keepeek/commons";
import {
  ComponentOverrideKey,
  KButtonAction,
  KButtonProps,
  useFontAwesomeIconSize,
} from "@keepeek/refront-components";
import { useTranslation } from "react-i18next";

import { getCustomerOverrideComponent } from "../../lib/overrides";
import { KIcon } from "../common/KIcon";

type DetailDownloadButtonProps = {
  // element was added to allow overrides for some customers
  element?: KpkMedia;
} & KButtonProps;

const DetailDownloadButton: FC<React.PropsWithChildren<DetailDownloadButtonProps>> = function ({
  element: _element,
  ...rest
}) {
  const { t } = useTranslation();
  const fontAwesomeIconSizeForActions = useFontAwesomeIconSize({
    belowSmIconName: "",
    aboveSmIconName: "",
  });

  return (
    <KButtonAction
      aria-label={t("media-detail.action.download.label")}
      title={t("media-detail.action.download.label")}
      {...rest}
    >
      <KIcon className={`fa-solid fa-fw fa-cloud-arrow-down ${fontAwesomeIconSizeForActions}`} />
    </KButtonAction>
  );
};

export default getCustomerOverrideComponent(
  ComponentOverrideKey.DetailDownloadButton,
  DetailDownloadButton,
);
